import { GoodPracticeForbidden } from "./components/GoodPracticeForbidden";

export default GoodPracticeForbidden;